import { makeAutoObservable } from "mobx";
import { OrgStore } from "./OrgStore";

export class OrgAddUserStore {
  orgStore: OrgStore;

  visible = false;
  saving = false;

  constructor(orgStore: OrgStore) {
    makeAutoObservable(this, {
      orgStore: false,
    });
    this.orgStore = orgStore;
  }
}
